import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class BaseHeader extends React.Component {
    render(){
        const {
            children,
            onSuperPrev,
            onSuperNext,
            onPrev,
            onNext,
        } = this.props;

        return (
            <div className="picker-panel-header">
                <button className={classnames({ "hidden": !onSuperPrev, "picker-header-super-prev-btn": true })} tabIndex="-1" onClick={onSuperPrev}><i className="iconfont icon-riqi-zuo1"></i></button>
                <button tabIndex="-1" className={classnames({ "hidden": !onPrev, "picker-header-prev-btn": true })} onClick={onPrev}><i className="iconfont icon-riqi-zuo2"></i></button>
                <div className="picker-header-view">{children}</div>
                <button tabIndex="-1" className={classnames({ "hidden": !onNext, "picker-header-next-btn": true })} onClick={onNext}><i className="iconfont icon-riqi-you2"></i></button>
                <button tabIndex="-1" className={classnames({ "hidden": !onSuperNext, "picker-header-super-next-btn": true })} onClick={onSuperNext}><i className="iconfont icon-riqi-you1"></i></button>
            </div>
        );
    }
}

BaseHeader.PropTypes = {
    onSuperPrev: PropTypes.func,
    onPrev: PropTypes.func,
    onSuperNext: PropTypes.func,
    onNext: PropTypes.func,
};

export default BaseHeader;